import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_approval_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_approval_hdr_guid: fromDatatype.GuidDataFieldInterface;
    submitter_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    submitted_date: fromDatatype.GuidDataFieldInterface;
    approval_status: fromDatatype.VarcharDatatypeInterface;
    approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    approver_name: fromDatatype.VarcharDatatypeInterface;
    approval_level: fromDatatype.IntegerDatatypeClass;
    approval_date: fromDatatype.GuidDataFieldInterface;
    approver_action: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.TextDatatypeClass;
    is_delegated_approval: boolean;
    delegating_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    delegating_approver_name: fromDatatype.VarcharDatatypeInterface;
    ip_address: fromDatatype.VarcharDatatypeInterface;
    esignature: fromDatatype.VarcharDatatypeInterface;
    cookies: fromDatatype.VarcharDatatypeInterface;
    property_json: any;
    namespace: fromDatatype.NamespaceDataFieldClass;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.GuidDataFieldInterface;
    updated_date: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldClass;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldClass;
}

export class bl_fi_generic_doc_approval_history_RowClass implements bl_fi_generic_doc_approval_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
    approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_approval_hdr_guid: fromDatatype.GuidDataFieldInterface;
    submitter_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    submitted_date: fromDatatype.GuidDataFieldInterface;
    approval_status: fromDatatype.VarcharDatatypeInterface;
    approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    approver_name: fromDatatype.VarcharDatatypeInterface;
    approval_level: fromDatatype.IntegerDatatypeClass;
    approval_date: fromDatatype.GuidDataFieldInterface;
    approver_action: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.TextDatatypeClass;
    is_delegated_approval: boolean;
    delegating_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    delegating_approver_name: fromDatatype.VarcharDatatypeInterface;
    ip_address: fromDatatype.VarcharDatatypeInterface;
    esignature: fromDatatype.VarcharDatatypeInterface;
    cookies: fromDatatype.VarcharDatatypeInterface;
    property_json: any;
    namespace: fromDatatype.NamespaceDataFieldClass;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.GuidDataFieldInterface;
    updated_date: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldClass;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldClass;
}
